import { render, staticRenderFns } from "./AlignGrid.vue?vue&type=template&id=bc1115f2&"
import script from "./AlignGrid.vue?vue&type=script&lang=ts&"
export * from "./AlignGrid.vue?vue&type=script&lang=ts&"
import style0 from "./AlignGrid.vue?vue&type=style&index=0&id=bc1115f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports